<template>
     <ion-card
  :style="{ '--i': i }"
  v-if="item.idBlockType === 7"
  class="custom-checkinout-card"
>
  <div class="badge">
   
    <span class="badge-text">{{ item.randomPercentage }}%</span>
  </div >
  <ion-card-header>
    <div class="title">
      <ion-card-title>
        <span class="text-20">{{ item.nome }}</span>
        <div class="timer">{{ timer }}</div>
        <div class="checkinout-button-container">
        <ion-button
          expand="block"
          style="width: 100%"
          :disabled="isCheckInDisabled"
          @click="handleCheckIn"
          :class="{ 'btn-check-in': !isCheckInDisabled, 'btn-disabled': isCheckInDisabled }"
        >
          Check In
        </ion-button>
        <ion-button
          expand="block"
          style="width: 100%"
          :disabled="isCheckOutDisabled"
          @click="handleCheckOut"
          :class="{ 'btn-check-out': !isCheckOutDisabled, 'btn-disabled': isCheckOutDisabled }"
        >
          Check Out
        </ion-button>
      </div>
      </ion-card-title>
    </div>
  </ion-card-header>
</ion-card>
</template>
<script>
import ApiService from '../../common/service.api';
import { useStore } from "vuex";
const store = useStore();
export default {
  name: "CheckInOutCard",
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
        isLoading: false,
        isCheckInDisabled: false,
      isCheckOutDisabled: true,
      timer: "00:00:00",
      timerInterval: null,
      lastActionType: null,
      showTimer: false,
    };
  },
  methods: {
    async handleCheckIn() {
     /*  const campaignId = this.$route.params.id; */
      this.isLoading = true;

      const payload = {
        id: 0,
        idCheckInOut: 0,
        idUser: this.$store.getters["user/getUserData"].id,
        idType: 1,
        type: "",
        eventDate: new Date().toISOString(),
        note: "",
        geofencing: "",
        checkin: true,
      };

      try {
        const response = await ApiService.post("UserCheckInOut/Add", payload);
        this.isCheckInDisabled = true;
        this.isCheckOutDisabled = false;
        this.showTimer = true;
        this.startTimer();
      } catch (error) {
        console.error("Error al registrar el Check In:", error);
      } finally {
        this.isLoading = false;
      }
    },


    async handleCheckOut() {
     /*  const campaignId = route.params.id; */
      this.isLoading = true;

      const payload = {
        id: 0,
        idCheckInOut: 0,
        idUser: this.$store.getters["user/getUserData"].id,
        idType: 2,
        type: '',
        eventDate: new Date().toISOString(),
        note: "",
        geofencing: "",
      };

      try {
        const response = await ApiService.post("UserCheckInOut/Add", payload);
        this.isCheckInDisabled = false;
        this.isCheckOutDisabled = true;
        this.showTimer = false;
        this.stopTimer();
        /* router.push(`/campaign-journey/${campaignId}/check-in`); */
      } catch (error) {
        console.error("Error al realizar el Check Out:", error);
      } finally {
        this.isLoading = false;
      }
    },


    startTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    let seconds = 0;
    this.timerInterval = setInterval(() => {
      seconds++;
      const hrs = String(Math.floor(seconds / 3600)).padStart(2, "0");
      const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
      const secs = String(seconds % 60).padStart(2, "0");
      this.timer = `${hrs}:${mins}:${secs}`;
    }, 1000);
  },

  stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
    this.timer = "00:00:00"; 
  },


  },
mounted() {
    const idUser = store.getters["user/getUserData"].id;
    ApiService.get(`UserCheckInOut/Gets/0/${idUser}`).then((data) => {
      const lastAction = data.data.sort(
        (a, b) => new Date(b.eventDate) - new Date(a.eventDate)
      )[0];

      if (lastAction) {
        this.lastActionType = lastAction.idType;
      }
    })
}
}

</script>
<style scoped>
 .custom-checkinout-card {
  background: #1C1C1C;
  color: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  overflow: hidden;
  }

.badge-text {
  font-size: 14px;
  font-weight: 600;
}

ion-card-header {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.4s ease forwards;
}
.timer {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 2rem;
  text-align: center;
  color: white;
}
.btn-check-in {
  background-color: green;
  color: white;
}

.btn-check-out {
  background-color: red;
  color: white;
}

.btn-disabled {
  background-color: lightgray !important;
  cursor: not-allowed;
  opacity: 0.6;
}
.checkinout-button-container  {
  display: flex;
  align-items: center;
  flex-direction: row;
}



</style>

